module.exports = __webpack_public_path__ + "static/value_targeting_and_business_analysis-e6cd3089c3514b10844e6b0d1b092589.jpg";